import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { pluginPlatformApi, type MarketplaceListing } from '../../api/pluginplatform';

export function PluginMarketplacePage() {
  const [listings, setListings] = useState<MarketplaceListing[]>([]);
  const [error, setError] = useState('');
  const [status, setStatus] = useState('');

  useEffect(() => {
    void pluginPlatformApi.marketplace().then((r) => setListings(r.listings)).catch((e) => setError(String(e)));
  }, []);

  async function install(pluginId: string) {
    try {
      await pluginPlatformApi.install(pluginId);
      setStatus(`Installed ${pluginId}`);
    } catch (e) {
      setError(String(e));
    }
  }

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/plugins" className="text-sm text-blue-600 hover:underline">← Plugin Hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Plugin Marketplace</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      {status && <p className="mt-4 text-sm text-green-600">{status}</p>}
      <div className="mt-6 grid gap-4 md:grid-cols-2">
        {listings.map((l) => (
          <div key={l.id} className="rounded-xl border p-4 dark:border-slate-700">
            <div className="flex items-start justify-between">
              <div>
                <p className="font-medium">{l.name}</p>
                <p className="text-sm text-slate-500">{l.category} · v{l.version}</p>
                <p className="mt-2 text-sm">{l.description}</p>
                <p className="mt-2 text-xs text-slate-400">★ {l.rating.toFixed(1)} · {l.downloads} downloads</p>
              </div>
              {l.featured && <span className="rounded bg-blue-100 px-2 py-0.5 text-xs text-blue-800">Featured</span>}
            </div>
            <button type="button" onClick={() => void install(l.plugin_id)} className="mt-4 rounded bg-blue-600 px-4 py-2 text-sm text-white">Install</button>
          </div>
        ))}
      </div>
    </div>
  );
}
